import { render, staticRenderFns } from "./LoadingFlux.vue?vue&type=template&id=10379461&scoped=true"
import script from "./LoadingFlux.vue?vue&type=script&lang=js"
export * from "./LoadingFlux.vue?vue&type=script&lang=js"
import style0 from "./LoadingFlux.vue?vue&type=style&index=0&id=10379461&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10379461",
  null
  
)

export default component.exports